module.exports = __webpack_public_path__ + "static/img/cont8.54aa19b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont8.jpg
// module id = jf7O
// module chunks = 0